import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * StepCard — wraps content in a soft glassmorphism card with entrance animation.
 */
export default function StepCard({ children, className = '' }) {
  return (
    <motion.div
      className={clsx(
        'relative w-full max-w-sm mx-auto rounded-3xl glass-card px-8 py-10 text-center',
        className
      )}
      initial={{ opacity: 0, y: 32, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -24, scale: 0.96 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
